import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import {
    MaterialSubcategoryBody,
    MaterialSubcategoryDetails,
    MaterialSubcategoryListItem,
} from "types/api/materialSubcategory";

function useMaterialSubcategoryApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllMaterialSubcategory = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<MaterialSubcategoryListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<MaterialSubcategoryListItem>>({
            url: "/material-subcategory",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneMaterialSubcategory = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<MaterialSubcategoryDetails> => {
        return get<PathParamsWithId, undefined, MaterialSubcategoryDetails>({
            url: "/material-subcategory/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createMaterialSubcategory = React.useCallback((body: MaterialSubcategoryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, MaterialSubcategoryBody, ResponseWithId>({
            url: "/material-subcategory",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateMaterialSubcategory = React.useCallback((pathParams: PathParamsWithId, body: MaterialSubcategoryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, MaterialSubcategoryBody, null>({
            url: "/material-subcategory/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteMaterialSubcategory = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/material-subcategory/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllMaterialSubcategory,
        getOneMaterialSubcategory,
        createMaterialSubcategory,
        updateMaterialSubcategory,
        deleteMaterialSubcategory
    };
}

export default useMaterialSubcategoryApi;